import React from 'react';
import { Button, type ButtonProps } from '@mui/material';
import { AgencyIcon } from '../AgencyIcon';

type Props = Omit<ButtonProps, 'onClick' | 'children'> & {
  onClick: () => void;
};

/** Botão «Monitorar Agências» — mesmo visual do Dashboard (MudancasMonitoramentoFiltros). */
export function MonitorarAgenciasButton({ onClick, size = 'medium', ...rest }: Props) {
  return (
    <Button
      variant="contained"
      size={size}
      startIcon={<AgencyIcon />}
      onClick={onClick}
      sx={{ height: 40, textTransform: 'none', fontWeight: 600 }}
      {...rest}
    >
      Monitorar Agências
    </Button>
  );
}
